import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Topbar from "../topbar/topbar";
import Sidebar from "../sidebar/sidebar";
import PoweredBy from "../common/poweredBy";

const Layout = () => {
  const location = useLocation();
  const isHelpPage = location.pathname === "/help";

  if (isHelpPage) {
    return <Outlet />;
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F5F8FA",
      }}
    >
      <div style={{ flexShrink: 0 }}>
        <Topbar />
      </div>

      <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
        <div style={{ flexShrink: 0 }}>
          <Sidebar />
        </div>

        <div
          className="hide-scroll"
          style={{
            flex: 1,
            overflowY: "auto",
            backgroundColor: "#F5F8FA",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ flex: 1 }}>
            <Outlet />
          </div>
          <PoweredBy />
        </div>
      </div>
    </div>
  );
};

export default Layout;
